import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ApplicantHome from "./pages/applicant/ApplicantHome";
import CultureGate from "./pages/applicant/CultureGate";
import AssessmentWizard from "./pages/applicant/AssessmentWizard";
import TrainingPortal from "./pages/applicant/TrainingPortal";
import OnboardingPortal from "./pages/applicant/OnboardingPortal";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ApplicantDetail from "./pages/admin/ApplicantDetail";

function Loader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#FAF9F6]">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#2C5545] border-t-transparent" />
    </div>
  );
}

function RoleRoute({ role, children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/portal"} replace />;
  }
  return children;
}

function Landing() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/culture"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/culture" element={<RoleRoute role="applicant"><CultureGate /></RoleRoute>} />
          <Route path="/portal" element={<RoleRoute role="applicant"><ApplicantHome /></RoleRoute>} />
          <Route path="/assessment" element={<RoleRoute role="applicant"><AssessmentWizard /></RoleRoute>} />
          <Route path="/training" element={<RoleRoute role="applicant"><TrainingPortal /></RoleRoute>} />
          <Route path="/onboarding" element={<RoleRoute role="applicant"><OnboardingPortal /></RoleRoute>} />
          <Route path="/admin" element={<RoleRoute role="admin"><AdminDashboard /></RoleRoute>} />
          <Route path="/admin/applicants/:id" element={<RoleRoute role="admin"><ApplicantDetail /></RoleRoute>} />
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
